//require("video.js");

import { Fancybox } from "@fancyapps/ui";
import { Carousel } from "@fancyapps/ui/dist/carousel/carousel.esm.js";
import { Thumbs } from "@fancyapps/ui/dist/carousel/carousel.thumbs.esm.js";

import {default as Slick} from 'slick-carousel';
import moment from 'moment';
import 'daterangepicker';
import 'jquery-smooth-scroll';
import Masonry from 'masonry-layout';

import intlTelInput from 'intl-tel-input';
import customSelect from './customselect';
import customInputNumber from './form-number';
import customDate from './form-date';

import * as util from './util';

import { Loader as GoogleMapsLoader } from "@googlemaps/js-api-loader"

import {default as BookingModel} from './model.js';

import {default as BookingPage} from './booking.js';
import {default as BookingAddonForm} from './booking-addon.js';
import {default as BookingPersonalDetailsForm} from './booking-continued.js';
import {default as BookingFailedPage} from './booking-failed.js';
import {default as Modal} from './modal.js';
import {default as Preloader} from './preloader.js';
import {QuickBookingForm} from './check-availability.js';

$(document).ready(function () {
    initLayout();
});

function initLayout() {
    var iti = null;

    $(function() {
      if ($('#fldCustomerMobilePhone').length) {
          intlTelInput($("#fldCustomerMobilePhone")[0], {
              utilsScript: SooriyaConfig.baseUrl + 'assets/front/vendor/intl-utils.js'
          });
      }
    });

    if ($('.show-embed-link').length) {
        var $link = $('.show-embed-link');
        $link.fancybox({
            type: "iframe",
            iframe: {
                tpl: $link.attr('data-tpl')
            }
        });
    }

    if ($('.special-offer-wrapper').length) {
        initOffersSection($('.special-offer-wrapper'));
    }

    // ---- nav bar ---
    $('#toggle').click(function () {
        $(this).toggleClass('active');
        
        $('header nav').toggleClass('open');
    });

    Modal.init();

    initHeader();
    initMain();
}

function initPackagesSection($root) {
    const $changeCurrencyForm = $root.find('.change-currency-form');

    $changeCurrencyForm.on('submit', function(e) {
		e.preventDefault();

		const nicValidation = initNICValidation($changeCurrencyForm);
		nicValidation.done(function() {
			const url = $root.attr('data-ajax-url');
			const baseurl = $root.attr('data-base-url');
			const category = $root.attr('data-category');
			const subcategory = $root.attr('data-subcategory');
			const currency = $changeCurrencyForm.find('.currency').val();

			Preloader.start();

			$.ajax(url, {
				method: 'GET',
				data: {
					"baseurl": baseurl,
					"category": category,
					"subcategory": subcategory,
					"currency": currency
				}
			}).done(function(responseData) {
				if (responseData.status == "error") {
					const errorCode = responseData.code;

					Modal.show("alert-modal", {
						"onSubmit": function() {
							location.reload();
						}
					});

					return;
				} else {
					const html = responseData.data.html;
					$root.find('.packages-list').replaceWith(html);
				}
			})
			.fail(function() {
				Modal.show('alert-modal', {});
			})
			.always(function() {
				Preloader.end();
			});
		});
    });

}

function lazyloadPictures($picture) {
    const deferred = jQuery.Deferred();
    
	/*
    if (util.mobileCheck()) {
        $picture.find('picture').not(':first').remove();
    }
	*/

    var loadPicture = function($picture) {
        let $img = $picture.find('img');
        let $source = $picture.find('source');
        $img.on('load', function() {
			$picture.removeClass('loading').addClass('loaded');
            deferred.resolve($picture);
        });
        $img.attr('srcset', $img.attr('data-srcset'));
        $img.attr('src', $img.attr('data-src'));
        $img.removeAttr('data-srcset');
        $img.removeAttr('data-src');

        $source.each(function(index, source) {
            const $current = $(source);
            $current.attr('srcset', $current.attr('data-srcset'));
            $current.removeAttr('data-srcset');
        });
    }

    loadPicture($picture);

    return deferred.promise();
}

function initNICValidation($form) {
    const deferred = jQuery.Deferred();

    const $currencySelect = $form.find('.currency');

	if ($form.hasClass('require-nic') && $currencySelect.val() == 'LKR') {
		Modal.show('nic-modal', {
			onShown: function($modal) {
				const $verifyNICForm = $modal.find('.verify-nic-form');
				$verifyNICForm.on('submit', function(e) {
					e.preventDefault();

					const url = $verifyNICForm.attr('action');
					let formData = $verifyNICForm.serialize();
					
					formData += '&currency=LKR';

					$.ajax(url, {
						data: formData,
						method: 'POST'
					}).done(function(responseData) {
						//if (responseData.status == "success") {
							$form.removeClass('require-nic');
							$currencySelect.val('LKR').change();
							Modal.hide();

							deferred.resolve();
						//}
					});
				});
			}
		});
	} else {
		deferred.resolve();
	}

	return deferred.promise();
};

function initHeader() {
    const $roomsForm = $('.rooms-form');

    $roomsForm.find('select').on('change', function(e) {
        if ($roomsForm.hasClass('require-nic') && $(this).val() == 'LKR') {
            Modal.show('nic-modal', {
                onShown: function($modal) {
                    const $verifyNICForm = $modal.find('.verify-nic-form');
                    $verifyNICForm.on('submit', function(e) {
                        e.preventDefault();

                        const url = $verifyNICForm.attr('action');
                        const formData = $verifyNICForm.serialize();

                        $.ajax(url, {
                            data: formData,
                            method: 'POST'
                        }).done(function(responseData) {
                            if (responseData.status == "success") {
                                $roomsForm.removeClass('require-nic');
                                $roomsForm.find('select').val('LKR').change();
                                Modal.hide();
                            }
                        });
                    });
                }
            });
            e.stopPropagation();
        } else {
            $roomsForm.submit();
        }
    });

    $roomsForm.on('submit', function(e) {
        e.preventDefault();

        const url = $roomsForm.attr('action');
        const formData = $roomsForm.serialize();

        $.ajax(url, {
            data: formData,
            method: 'GET'
        }).done(function(responseData) {
            if (responseData.status == "success") {
                const prices = responseData.data.prices;

                $('.rooms .item').each(function(index, room) {
                    const roomId = $(room).attr('data-id');
                    const roomPrice = prices[roomId];
                    $(room).find('.price .value').html(roomPrice);
                });

                $('.suites .item').each(function(index, room) {
                    const roomId = $(room).attr('data-id');
                    const roomPrice = prices[roomId];
                    $(room).find('.price .value').html(roomPrice);
                });
            }
        });
    });

    const $packagesSection = $('section.packages');
    
    const $packagesForm = $packagesSection.find('.packages-form');

    $packagesForm.find('select').on('change', function(e) {
        if ($packagesForm.hasClass('require-nic') && $(this).val() == 'LKR') {
            Modal.show('nic-modal', {
                onShown: function($modal) {
                    const $verifyNICForm = $modal.find('.verify-nic-form');
                    $verifyNICForm.on('submit', function(e) {
                        e.preventDefault();

                        const url = $verifyNICForm.attr('action');
                        const formData = $verifyNICForm.serialize();

                        $.ajax(url, {
                            data: formData,
                            method: 'POST'
                        }).done(function(responseData) {
                            if (responseData.status == "success") {
                                $packagesForm.removeClass('require-nic');
                                $packagesForm.find('select').val('LKR').change();
                                Modal.hide();
                            }
                        });
                    });
                }
            });
            e.stopPropagation();
        } else {
            $packagesForm.submit();
        }
    });

    $packagesForm.on('submit', function(e) {
        e.preventDefault();

        const url = $packagesForm.attr('action');
        const formData = $packagesForm.serialize();

        $.ajax(url, {
            data: formData,
            method: 'GET'
        }).done(function(responseData) {
            if (responseData.status == "success") {
                const html = responseData.data.html;

                $packagesSection.find('.packages-list').html($(html).find('.packages-list'));
            }
        });
    });

    $('a.scroll-down').on('click', function(e) {
        e.preventDefault();

        event.preventDefault();
        var link = this;
        $.smoothScroll({
          scrollTarget: link.hash
        });
    });

    $('.js-toggle-menu').click(function(e) {
        e.preventDefault();
        $(this).parents('nav').toggleClass('open');
    });

    $('.flags-menu').find('.js-toggle').on('click', function() {
        $('.flags-menu').toggleClass('open');
    });
	
	/*
    const $pictures = $('header .pictures.slider');

    lazyloadPictures($pictures).then(function($pictures) {
        $pictures.slick({
            dots: true,
            infinite: true,
            speed: 600,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            pauseOnHover: false,
            autoplay: true,
            autoplaySpeed: 4000,
        });
    });
	*/

    function scrollMenubar($nav) {
        const $window = $(window);
		const $toggler = $nav.find('.menu-toggler')

        if ($window.scrollTop() > 50) {
            $nav.addClass('scrolled');
			switchToActiveLogo($nav);
        } else {
            $nav.removeClass('scrolled');
			if ($nav.is(':not(.open)')) {
				switchToDefaultLogo($nav);
			}
        }
    }

	function switchToActiveLogo($nav) {
        const $logo = $nav.find('.logo');
        const $logoImg = $logo.find('img');

		$logoImg.attr('src', $logoImg.attr('data-src-scrolled'));
	}

	function switchToDefaultLogo($nav) {
        const $logo = $nav.find('.logo');
        const $logoImg = $logo.find('img');

		$logoImg.attr('src', $logoImg.attr('data-src'));
	}

    const $nav = $('header nav');

    if ($nav.is('.fixed')) {
        $(window).scroll(function (e) {
            scrollMenubar($nav);
        });

        scrollMenubar($nav);
    }

	$nav.find('.menu-toggler').on('click', function(event) {
		if ($(this).is('.active')) {
			switchToActiveLogo($nav);
		} else {
			switchToDefaultLogo($nav);
		}
	});
}

function initContact($body) {
    const loader = new GoogleMapsLoader({
        apiKey: "AIzaSyBIi-8Zk5Gweylu2kNpn8s9UdlO9ApgFoU",
        version: "weekly"
    });

	const $iframe = $body.find('iframe');
	$iframe.css({'height': $iframe.width()});

	$(window).on('resize', function() {
		$iframe.css({'height': $iframe.width()});
	});

    loader.load().then(async () => {
        const { Map } = await google.maps.importLibrary("maps");

        const map = new Map(document.getElementById("contactmap"), {
            center: { lat: 6.047250588524076, lng: 80.86647320921902 },
            zoom: 14,
        });

		google.maps.event.addDomListener(window, "resize", function() {
			var center = map.getCenter();
			google.maps.event.trigger(map, "resize");
			map.setCenter(center); 
		});
    });

    const $form = $('.contact-form');

	$form.find('button.primary').on('click', function(event) {
		event.preventDefault();

		grecaptcha.enterprise.ready(async () => {
			const token = await grecaptcha.enterprise.execute('6LcAGNgtAAAAADcBS3GxWcBwiLSOgDmJ-greCYd6', {action: 'CONTACT'});
			$form.find('.recaptcha-token').val(token);
			$form.submit();
		});
	});

    $form.submit(function(e) {
        e.preventDefault();

        const fetchUrl = $form.attr('action');
        const formData = $form.serialize();

        $.ajax(fetchUrl, {
            data: formData,
            method: 'POST'
        }).done(function(responseData) {
            if (responseData.status == 'success') {
                $form.replaceWith('<div class="messagebox success">Thank you for contacting Sooriya Resort & Spa. We will review your message and get back to you soon.</div>');
            } else if (responseData.status == 'error') {
                $form.append('<div class="messagebox error">Unable to process your request. Please contact info@sooriya.com</div>');
            }
        });
    });
}

function initBookingAddon($body) {
    const $form = $body.find('form.bookaddonform');
    const formObj = new BookingAddonForm($form);    
}

function initBookingContinued($body) {
    const $form = $body.find('form.paymentdetailsform');
    const formObj = new BookingPersonalDetailsForm($form);
}

function initBookingFailed($body) {
    const page = new BookingFailedPage($body);
}

function initBookingSuccess($body) {
	const data = JSON.parse($('.booking_request_data').val());

	let grooms = [];

	$.each(data.rooms, function(index, item) {
		grooms.push({
			item_id: item.roomId,
			item_name: item.name,
			item_category: 'Accommodation',
			price: item.price,
			index: index
		});
	});

	dataLayer.push({
		"ecommerce": null,
		"event": 'purchase',
		"ecommerce": {
			'transaction_id': $('.booking-reference').html(),
			"currency": data.currency,
			"value": data.totals.total,
			"items": grooms
		}
	});
}

function initMain() {
    const $body = $('body');
    
    $body.find('form input[type=number]').each(function(index, input) {
        customInputNumber($(input));
    });

    $body.find('form select.custom').each(function(index, select) {
        customSelect($(select));
    });

/*
    $body.find('form').each(function(index, form) {
        const $form = $(form);

        $form.on('change', 'select', function(e) {
            const $target = $(e.target);
            const optionText = $target.find('option:selected').html();
            $target.parents('.input-wrapper').find('.placeholder-wrapper').find('.text').html(optionText);
        });
    });
*/
    try {
        if ($body.is('.page-home')) {
            initHome($body);
        } else if ($body.is('.page-contact')) {
            initContact($body);
        } else if ($body.is('.page-booking.step1')) {
            BookingPage.init($body);
        } else if ($body.is('.page-booking.step2')) {
            initBookingAddon($body);
        } else if ($body.is('.page-booking.step3')) {
            initBookingContinued($body);
        } else if ($body.is('.page-paymentRequest-failed')) {
            initBookingFailed($body);
        } else if ($body.is('.page-accommodation-single')) {
            initSingleAccommodation($body);
        } else if ($body.is('.page-wellness')) {
            initWellnessPage($body);
        } else if ($body.is('.page-offer-single')) {
            initViewPackagePage($body);
        } else if ($body.is('.page-blog')) {
            initBlogPage($body);
        } else if ($body.is('.page-deals')) {
			initDealsPage($body);
		} else if ($body.is('.page-adventure')) {
			initAdventurePage($body);
		} else if ($body.is('.page-booking-success')) {
			initBookingSuccess($body);
		}
    } catch (exception) {
        console.log(exception);
    }

	initPackagesSection($body.find('section.packages'));

    if ($('.center-slider')) {
        initCenterSlider($('.center-slider'));
    }

    let $pictureGroups = $('picture.lazyload');
    const loadInView = function() {
        $.each($pictureGroups, function() {
			const wTop = $(window).scrollTop();
			const wBottom = $(window).scrollTop() + $(window).height();
			const top = $(this).offset().top;
			const bottom = $(this).offset().top + $(this).parents('.image').parent().height();

            if ( !$(this).is('.loading') && !$(this).is('.loaded') && 
                (top > wTop && top < wBottom + 100) ||
				(bottom > wTop && bottom < wBottom + 100)
			) {
                    $(this).addClass('loading');
                lazyloadPictures($(this));
            }
        })
    };

    loadInView();

    $(window).scroll(function() {
        loadInView();
    })
}

function initAdventurePage($root) {
	//const masonry = new Masonry($root.find('.activities-list')[0], {
	//  itemSelector: '.activity'
	//});
}

function initDealsPage($root) {
	const $section = $root.find('.discounts');
    const $changeCurrencyForm = $root.find('.change-currency-form');

    $changeCurrencyForm.on('submit', function(e) {
		e.preventDefault();

		const nicValidation = initNICValidation($changeCurrencyForm);
		nicValidation.done(function() {
			const url = $section.attr('data-ajax-url');
			const currency = $changeCurrencyForm.find('.currency').val();

			Preloader.start();

			$.ajax(url, {
				method: 'GET',
				data: {
					"currency": currency
				}
			}).done(function(responseData) {
				if (responseData.status == "error") {
					const errorCode = responseData.code;

					Modal.show("alert-modal", {
						"onSubmit": function() {
							location.reload();
						}
					});

					return;
				} else {
					const html = responseData.data.html;
					$root.find('.deals-list').replaceWith(html);
				}
			})
			.fail(function() {
				Modal.show('alert-modal', {});
			})
			.always(function() {
				Preloader.end();
			});
		});
    });

	$section.find('.deals-list').on('click', '.discount-code', function(event) {
		const $target = $(this);
		const code = $target.find('.value').html();
		const $icon = $target.find('i');

		navigator.clipboard.writeText(code).then(function() {
			$target.addClass('copied');

			$icon.removeClass('fa-copy');
			$icon.addClass('fa-check');

			setTimeout(() => {
				$target.removeClass('copied');
				$icon.removeClass('fa-check');
				$icon.addClass('fa-copy');
			}, 2000);
		});
	});
}

function initBlogPage($root) {
    const $subscribeForm = $('.subscribe-form');

    $subscribeForm.submit(function(e) {
        e.preventDefault();

        const fetchUrl = $subscribeForm.attr('action');
        const formData = $subscribeForm.serialize();

        $.ajax(fetchUrl, {
            data: formData,
            method: 'POST'
        }).done(function(responseData) {
            if (responseData.status == 'success') {
                $subscribeForm.replaceWith('<div class="messagebox success">Thank you for your subscription. We will send an email shortly.</div>');
            } else if (responseData.status == 'error') {
                $subscribeForm.append('<div class="messagebox error">We could not process your subscription request. Please try again.</div>');
            }
        });
    });
}

function initViewPackagePage($root) {
    const $form = $('.select-offer-form');
    const $totalPriceWrapper = $root.find('.total-price-wrapper');
    const $price = $totalPriceWrapper.find('.price');
    const $priceValue = $price.find('.value');

    const $deals = $root.find('.deals');

    $root.find('.radio-offer').on('click', function(e) {
        $deals.find('.deal').removeClass('selected');

        const $selectedDeal = $(this).parents('.deal');
        $selectedDeal.addClass('selected');

        const type = $selectedDeal.attr('data-type');
        const price = parseFloat($selectedDeal.attr('data-price-value'));
        const people = parseInt($selectedDeal.find('.addon-guests').val());

        if (type == 'fixed') {
            $priceValue.html(price);
        } else if (type == 'addon') {
            $priceValue.html(price * people);
        }
    });

    $root.find('.addon-guests').on('change', function(e) {
        const $selectedDeal = $(this).parents('.deal');

        if (!$selectedDeal.is('selected')) {
            $selectedDeal.find('.radio-offer').click();
        } else {
            const price = parseFloat($selectedDeal.attr('data-price-value'));
            const people = parseInt($(this).val());

            $priceValue.html(price * people);
        }
    });

	let $checkindateField = $root.find('.checkindate');
    let minDate = moment();
    let maxDate = moment();
    maxDate.add(365, 'days');

	let maxDateAttr = $checkindateField.attr('data-maxdate');

	if (maxDateAttr) {
		maxDate = moment(maxDateAttr);
	}

	customDate($root.find('.checkindate'), {
		"minDate": minDate,
		"maxDate": maxDate
	});
}

function initWellnessPage($root) {
    
}

function initSingleAccommodation($root) {
    const $thumbsContainer = $root.find('.thumbnails');

    const options = {
        Autoplay: {
            timeout: 1000,
        },
        Thumbs: {
            type: "classic",
        }
    };

    const carouselInstance = new Carousel($thumbsContainer[0], options, { Thumbs });

    $thumbsContainer.css('visibility', 'visible');

    Fancybox.bind('[data-fancybox="gallery"]', {
        placeFocusBack: false,
        idle: false,
        compact: false,
        dragToClose: false,

        showClass: 'f-fadeIn',
        hideClass: 'f-fadeOut',

        Images: {
            zoom: false,
        },

        Thumbs: {
            type: 'classic',
        },

        on: {
            'Carousel.ready Carousel.change': (fancybox) => {
                const titleVal = fancybox.getSlide().triggerEl.dataset.title;
                const titleEl = document.getElementById('fancybox_title');

                if (titleEl) {
                    titleEl.innerHTML = titleVal;
                }
            },
        }
    });

    $root.find('.gallery .thumbnails').on('click', 'picture', function(e) {
        e.preventDefault();

        const $picture = $(e.target);

        $root.find('.gallery-modal').find('.picture-wrapper').html($picture.clone());

        Modal.show('gallery-modal');
    });

    $root.find('.gallery .image').on('click', function(e) {
        e.preventDefault();

        const $picture = $(this).find('picture');

        $root.find('.gallery-modal').find('.picture-wrapper').html($picture.clone());

        Modal.show('gallery-modal');
    });

    const $alternativesCarousel = $root.find('.rooms .list');

    $alternativesCarousel.slick({
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        autoplay: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1
                }
            },
        ]
    });

    $alternativesCarousel.css('visibility', 'visible');
}

function initCenterSlider($slider) {
    $slider.slick({
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        autoplay: true,
        pauseOnHover: false,
        autoplaySpeed: 5000,
        centerMode: true,
        centerPadding: '0px',
        responsive: [
			{
                breakpoint: 1024,
                settings: {
                    centerPadding: '0px',
                }
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '0px',
                }
            }, {
                breakpoint: 480,
                settings: {
                    centerPadding: '0px',
                }
            }
        ]
    });
}

function initSpecialEvents($root) {
    const $slider = $root.find('.events-slider');

    $slider.slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        autoplay: false,
        pauseOnHover: false,
        autoplaySpeed: 8000,
        centerMode: true,
        centerPadding: '120px',
        responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
}

function initHomeTestimonials($root) {
    const $modal = $('.review-modal');

    $modal.on('click', '.nav .prev', function(e) {
        e.preventDefault();

        const $link = $(e.target);
        loadReviewFunc($link.attr('href'));
    });

    $modal.on('click', '.nav .next', function(e) {
        e.preventDefault();

        const $link = $(e.target);
        loadReviewFunc($link.attr('href'));
    });

    var loadReviewFunc = function(url) {
        $.get(url, function(response) {
            const review = response.data[0];

            const $modal = $('.review-modal');
            const $source = $modal.find('.review-source');
            $source.find('.label').html(review.source.label);
            $source.find('i').attr('class', 'icon-source-' + review.source.code);
            if (review.rating) {
                const $score = $modal.find('.score');
                $score.find('.value').html(review.rating);
                $score.find('.max').html(review.ratingMax);
            }
            $modal.find('.review-client').html(review.client);
            $modal.find('.review-country').html(review.country);
            $modal.find('.review-title').html(review.title);
            $modal.find('.review-text').html($.parseHTML(review.reviewText));
            
            const $nav = $modal.find('.nav');
            $nav.find('.prev').attr('href', review.urls.prev);
            $nav.find('.next').attr('href', review.urls.next);

            Modal.show('review-modal');
        });
    };
    
    $root.find('.testimonials-slider').on('click', '.readmore', function(e) {
        e.preventDefault();
        var $link = $(this);
        var $reviewWrapper = $link.parents('.reviews-detail-wrapper').clone();
        $reviewWrapper.find('.review-text-full').removeClass('hide');
        $reviewWrapper.find('.review-text').remove();

        loadReviewFunc($link.attr('href'));
    });

    const $slick = $root.find('.testimonials-slider').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: false,
        autoplaySpeed: 4000,
        responsive: [{
            breakpoint: 1024,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
    });
}

function initHome($root) {
    const $testimonials = $root.find('section.accolades');
    initHomeTestimonials($testimonials);

    initSpecialEvents($root.find('section.special-events'));

    const bookingModel = new BookingModel();
    const formComponent = new QuickBookingForm($root.find('form.bookform'), bookingModel);
}